import { render, staticRenderFns } from "./Bookmarks.vue?vue&type=template&id=51a6aefc"
import script from "./Bookmarks.vue?vue&type=script&lang=ts"
export * from "./Bookmarks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports